import script from "./EditMembershipModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditMembershipModal.vue?vue&type=script&lang=ts&setup=true"

export default script